import { Edit, SimpleForm, SelectInput, useRecordContext } from 'react-admin';
import { Box, Typography, Card, CardContent, Stack, Chip } from '@mui/material';

const tallInput = { '& .MuiInputBase-root': { minHeight: 48 } };

const OrderTitle = () => {
    const record = useRecordContext();
    return <span>{record ? `Заказ №${record.id}` : ''}</span>;
};

const OrderDetails = () => {
    const record = useRecordContext();
    if (!record) return null;
    const user = record.user || {};
    const userName = [user.firstName, user.lastName].filter(Boolean).join(' ') || '—';
    const products = record.products || [];

    return (
        <Stack spacing={2}>
            <Card sx={{ bgcolor: '#fafafa' }}>
                <CardContent>
                    <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>Клиент</Typography>
                    <Stack spacing={0.5}>
                        <Typography variant="body2"><strong>Имя:</strong> {userName}</Typography>
                        <Typography variant="body2"><strong>Телефон:</strong> {user.phone || '—'}</Typography>
                    </Stack>
                </CardContent>
            </Card>

            {products.length > 0 && (
                <Card sx={{ bgcolor: '#fafafa' }}>
                    <CardContent>
                        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>Товары</Typography>
                        <Stack spacing={0.5}>
                            {products.map((p, i) => (
                                <Typography key={i} variant="body2">
                                    {p.name} — {p.price?.toLocaleString('ru-RU')} ₽
                                </Typography>
                            ))}
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                <strong>Сумма:</strong> {record.price?.toLocaleString('ru-RU')} ₽
                            </Typography>
                        </Stack>
                    </CardContent>
                </Card>
            )}

            {record.comment && record.comment !== 'empty' && (
                <Card sx={{ bgcolor: '#FFF8E1' }}>
                    <CardContent>
                        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>Комментарий</Typography>
                        <Typography variant="body2">{record.comment}</Typography>
                    </CardContent>
                </Card>
            )}
        </Stack>
    );
};

const OrderEdit = () => (
    <Edit title={<OrderTitle />}>
        <SimpleForm>
            <OrderDetails />
            <SelectInput source="status" label="Статус" choices={[
                { id: 'Новый', name: 'Новый' },
                { id: 'Подтверждён', name: 'Подтверждён' },
                { id: 'Отправлен', name: 'Отправлен' },
                { id: 'Доставлен', name: 'Доставлен' },
                { id: 'Отменён', name: 'Отменён' },
            ]} fullWidth sx={tallInput} />
        </SimpleForm>
    </Edit>
);

export default OrderEdit;
